<script setup>

const crumbs = computed(() => {
    return useBreadCrumbs()
})
</script>
<template>
    <v-breadcrumbs :items="crumbs" class="text-title" active-class="item-active">
        <template v-slot:divider>
            <v-icon icon="mdi-chevron-right"></v-icon>
        </template>
        <template v-slot:prepend>
            <v-icon icon="mdi-home"></v-icon>
            <v-icon icon="mdi-chevron-right"></v-icon>
        </template>
        <template v-slot:item="{ item }">
            <v-breadcrumbs-item :title="item.title" :active="item.active" :to="item.href" :disabled="item.disabled"/> 
        </template>
    </v-breadcrumbs>
</template>
<style scoped>
.item-active {
    opacity: 0.4 !important;
    background-color: #1E88E5!important;
    padding: 2px 5px 2px 5px !important;
    border-radius: 7px !important;
    color: white!important;
}
</style>